<script lang="ts">
  import Button from '$src/js/components/molecules/button/Button.svelte';
  import BaseModule from '$src/js/modules/base/BaseModule';
  import { VoteState } from '$src/js/states/VoteState.svelte';
  import { onMount } from 'svelte';

  let scrolled = false;
  const currentLang = document.documentElement.lang || 'en';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const changeLang = (e: Event) => {
    const lang = (e.target as HTMLSelectElement).value;
    const urls: Record<string, string> = {
      nl: 'https://thearchitect.teamvismaleaseabike.nl/',
      en: 'https://thearchitect.teamvismaleaseabike.com/',
    };

    window.location.href = urls[lang] ?? '/';
  };

  onMount(() => {
    window.addEventListener('scroll', () => {
      scrolled = window.scrollY > 100;
    });
  });
</script>

<div class="header">
  <div class="header-content relative z-1">
    <div
      class="flex items-center justify-between p-4 transition-all duration-300 {scrolled
        ? 'md:p-6'
        : 'md:px-16 md:py-10'}"
    >
      <a
        href={currentLang === 'nl'
          ? 'https://www.teamvismaleaseabike.nl/'
          : 'https://www.teamvismaleaseabike.com/'}
        target="_blank"
      >
        <img
          class="h-12 transition-all duration-300 {scrolled ? 'md:h-18' : 'md:h-24'}"
          src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-tvl-yellow.svg"
          alt="TVL Logo"
        />
      </a>

      <button class="absolute left-1/2 -translate-x-1/2" onclick={scrollToTop}>
        <img
          class="h-14 transition-all duration-300 {scrolled ? '' : 'md:h-18'}"
          src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-the-architect-2.svg"
          alt="The Architect Logo"
        />
      </button>

      <div class="flex gap-8">
        {#if !VoteState.votingEnded}
          <div class="max-lg:hidden">
            <Button
              size="small"
              text={BaseModule.getInstance().i18n.translate('cta_button')}
              type="submit"
              onclick={() => BaseModule.getInstance().scroll.scrollToVote()}
            />
          </div>
        {/if}

        <select class="lang-switch" value={currentLang} onchange={changeLang}>
          <option value="nl">NL</option>
          <option value="en">EN</option>
        </select>
      </div>
    </div>
  </div>
</div>

{#if !VoteState.votingEnded}
  <div
    class="fixed right-0 bottom-0 left-0 z-50 flex items-center justify-center px-4 py-8 lg:hidden"
  >
    <Button
      size="small"
      text={BaseModule.getInstance().i18n.translate('cta_button')}
      type="submit"
      onclick={() => BaseModule.getInstance().scroll.scrollToVote()}
    />
  </div>
{/if}

<style>
  @reference '$src/css/main.css';

  .header {
    @apply fixed top-0 right-0 left-0 z-50;
    @apply after:pointer-events-none after:absolute after:top-1/2 after:-right-10 after:-left-10 after:h-110 after:-translate-y-1/2 after:bg-[radial-gradient(50%_50%_at_50%_100%,rgba(0,0,0,0)_99.99%,rgba(0,0,0,0.5)_100%)] after:opacity-80 after:blur-2xl after:content-[''];
  }

  .lang-switch {
    @apply w-14 scale-87 leading-[150%] font-extrabold tracking-[0.175em] text-white uppercase;
    @apply appearance-none bg-[url('https://yellow-b-global.b-cdn.net/production/the-architect/images/dropdown.svg')] bg-size-[18px] bg-position-[right_4px_center] bg-no-repeat;
  }
</style>
